import { Handle, Position } from '@xyflow/react';

const CENTER_STYLE = { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };

// Edges should always run from the visual center of a card, not from wherever
// react-flow's default top/bottom anchors land — both handles sit on top of
// each other at dead center, invisible, so straight edges connect there.
export function CenteredHandles() {
  return (
    <>
      <Handle type="target" position={Position.Top} isConnectable={false} className="!invisible" style={CENTER_STYLE} />
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={false}
        className="!invisible"
        style={CENTER_STYLE}
      />
    </>
  );
}
